import React, { useState } from 'react';
import { Grid, InputLabel, MenuItem } from '@mui/material';
import { PrimaryOutlinedButton, PrimaryLightInput, PrimaryLightSelect } from '../../theme/index'
import '../../sass/styles.scss';
import FormControl from '@mui/material/FormControl';
import { useDispatch } from 'react-redux';
import { modalAction } from '../../redux/reducers/Modal';
import { createLevelAction } from '../../redux/reducers/Create';

const CreateLevel = () => {

    const dispatch = useDispatch();
    const [name, setName] = useState('');
    const [status, setStatus] = useState('');

    const saveData = async () => {
        const level = new FormData();
        const dataNames = ['name', 'status'];

        level.append(dataNames[0], name);
        level.append(dataNames[1], status);
        level.append('METHOD', 'POST');

        dispatch(createLevelAction(level, dataNames));
        dispatch(modalAction());
    }

  return (
    <>
        <Grid item xs={ 10 }>
            <h5 style={{ margin: '0' }}>Nivel / nuevo</h5>
        </Grid>
        <Grid item xs={ 12 }>
            <Grid container sx={{ py: 3 }}>
                <Grid item xs={ 6 } sx={{ mb: 2}} className='pr-2'>
                    <PrimaryLightInput
                        label="Nombre"
                        fullWidth
                        onChange={ e => setName(e.target.value) }
                    />
                </Grid>
                <Grid item xs={ 6 } sx={{ mb: 2}} className='pr-2'>
                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Status</InputLabel>
                        <PrimaryLightSelect 
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Status"
                        onChange={ e => setStatus(e.target.value) }
                        >
                            <MenuItem value='true'>Activo</MenuItem>
                            <MenuItem value='false'>Inactivo</MenuItem>
                        </PrimaryLightSelect>
                    </FormControl>
                </Grid>
            </Grid>
        </Grid>
        <Grid item xs={ 12 } sx={{ mt: 2 }} textAlign='end' className='pr-2'>
            <PrimaryOutlinedButton onClick={ () => saveData() }>Guardar</PrimaryOutlinedButton>
        </Grid>
    </>
  )
}

export default CreateLevel